import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_H_C, LL_V_L, TS_Checkbox, TS_PropRenderer } from '@nu-art/thunderstorm-frontend';
import './Editor_ReferencablePrototypes.scss';
import { referencablePropType_LabelMap, referencablePropTypes } from '@app/hcs-shared/hcs-v2';
import { DropDown_Referencable } from '../../_entity/referencable/ui-components.js';
export class Editor_ReferencablePrototypes extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state.editable = nextProps.editable;
        return state;
    }
    render() {
        const prototypes = this.state.editable;
        return _jsx(LL_H_C, { className: 'editor__referencable-prototypes', children: prototypes.item.map((prototype, index) => {
                const editable = prototypes.editProp(index, {});
                return this.render_Editor_Prototype(editable);
            }) });
    }
    render_Editor_Prototype = (editable) => {
        return _jsxs(LL_V_L, { className: 'editor__referencable-prototype', children: [this.render_Editor_PrototypeId(editable), this.render_Editor_PrototypeTypes(editable)] }, editable.item.id);
    };
    render_Editor_PrototypeId = (editable) => {
        return _jsx(TS_PropRenderer.Horizontal, { label: 'Referencable', children: _jsx(DropDown_Referencable.editable, { editable: editable, prop: 'id' }) });
    };
    render_Editor_PrototypeTypes = (editable) => {
        const types = editable.editProp('types', []);
        return _jsx(TS_PropRenderer.Vertical, { label: 'Type', children: _jsx(LL_H_C, { className: 'editor__referencable-prototype-types', children: referencablePropTypes.map((type, index) => {
                    const checked = editable.item.types.includes(type);
                    return _jsx(TS_Checkbox, { checked: checked, onCheck: () => {
                            if (checked)
                                types.removeArrayItem(index);
                            else
                                types.updateArrayAt(type);
                        }, children: referencablePropType_LabelMap[type] }, type);
                }) }) });
    };
}
//# sourceMappingURL=Editor_ReferencablePrototypes.js.map